/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */

'use strict';

module.exports = {

	read: function (str) {
		return str;
	},

	write: function (obj) {
		return obj.toString();
	}

};



//////////////////
// WEBPACK FOOTER
// ./~/rest/mime/type/text/plain.js
// module id = 773
// module chunks = 2